var React = require('react');

function Profile1Path (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"profile-1","fill":"none","stroke":"rgb(250,250,240)","strokeLinecap":"butt","strokeLinejoin":"miter","strokeWidth":"2","d":"M1438.7,173.51c-293.92-23.78-473.92-318.95-988-79.21C256.88,184.66,110.44,190.52.31,154.11"}));
}

Profile1Path.defaultProps = {"viewBox":"0 0 1438.78 176.03"};

module.exports = Profile1Path;

Profile1Path.default = Profile1Path;
